import React, { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// function handleResize() {
//   // ScrollTrigger.refresh(true)
// }

const Card = ({ category, rotation, id, lang, parentHeight }) => {
  const content = useRef(null)

  useEffect(() => {
    window.onbeforeunload = function() {
      window.scrollTo(0, 0)
    }
  }, [])

  // useEffect(() => {
  //   window.addEventListener('resize', handleResize)
  // }, [])

  if (id > 1) {
    useEffect(() => {
      const element = content.current
      // gsap.fromTo(
      //   element,
      //   {
      //     opacity: 1,
      //     y: -20
      //   },
      //   {
      //     opacity: 0,
      //     y: 0,
      //     scrollTrigger: {
      //       trigger: element,
      //       start: "center center",
      //       end: "top bottom",
      //       scrub: true
      //     }
      //   }
      // )
      ScrollTrigger.create({
        trigger: element,
        start: 'center center',
        end: '+=' + String((id - 1) * 100) + '%',
        pin: true,
        pinSpacing: false,
        pinType: 'fixed'
      })
    }, [])
  }

  return (
    <section
      ref={content}
      style={{
        transform: `rotate(` + rotation + `deg)`,
        zIndex: 5 - id
      }}
      className={'pin' + category + id}
      id={'pin' + category + id}
    >
      <img
        className='playingCard'
        src={require('images/cards/' + lang + '/' + category + id + '.png')}
      />
    </section>
  )
}

export default Card
